import script from "./ItemIcone.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemIcone.vue?vue&type=script&setup=true&lang=js"

import "./ItemIcone.vue?vue&type=style&index=0&id=19b93e5b&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b93e5b"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
